<template>
  <div class="pt-20 pb-10" id="ads">
    <!-- Banner -->
    <div class="text-center">
      <div>
        <h1 class="font-bold font-sans text-3xl lg:text-[44px] text-stone-800 dark:text-white">一个在浏览器中免费制作GIF的网站</h1>
        <p class="text-x mt-5 text-gray-500 tracking-[10px]">EASY GIF</p>
      </div>
    </div>
    <div class="text-center">
      <HomeSvg></HomeSvg>
    </div>
    <div class="px-5 md:px-10 lg:py-10 lg:px-30">
      <h1 class="text-center text-2xl lg:text-3xl font-bold my-5">网站优势</h1>
      <div class="grid grid-cols-2 gap-5 lg:grid-cols-3 lg:gap-12 py-2 lg:py-7 px-0">
        <div
          v-for="(item, index) in recommendList"
          :key="index"
          class="text-center px-4 py-2 lg:px-5 lg:py-5 shadow-[0_10px_30px_0_rgba(176,191,231,0.55)] rounded-xl f-c flex-col gap-1 lg:gap-4"
        >
          <h2 class="text-base lg:text-xl font-semibold">{{ item.title }}</h2>
          <SvgIcon :name="item.icon!" class="text-3xl text-primary lg:text-5xl" />
          <p class="text-xs lg:text-base">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <!-- Menu -->
    <div class="px-5 md:px-10 lg:py-10 lg:px-30 mb-20">
      <h1 class="text-center text-2xl lg:text-3xl font-bold my-5">GIF工具导航</h1>
      <div v-for="route in routes" :key="route.path">
        <h2 class="text-primary text-xl lg:text-2xl font-bold my-4">{{ route.meta?.title }}</h2>
        <div class="grid justify-center grid-cols-2 lg:grid-cols-[repeat(4,1fr)] gap-y-3 gap-x-2 lg:gap-x-8">
          <LinkCard v-for="item in route.children" :key="item.meta?.title" :path="item.path" :meta="item.meta"></LinkCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: 'default',
  title: '首页',
  svgIcon: 'home',
  keywords:
    'GIF,免费gif制作,简易gif,动图制作免费软件,gif在线制作免费,动图制作,gif生成软件,gif动图,gif中文网,在线工具,图片,视频,转换,编辑,制作,生成,动图',
  description: 'GIF在线工具，提供GIF图片、视频转换、编辑、制作、生成等功能，免费快捷制作GIF动图。',
  sort: 0,
});

const title = 'easygif-首页';
const description = 'GIF在线工具，提供GIF图片、视频转换、编辑、制作、生成等功能，免费快捷制作GIF动图。';
const keywords =
  'GIF,免费gif制作,简易gif,动图制作免费软件,gif在线制作免费,动图制作,gif生成软件,gif动图,gif中文网,在线工具,图片,视频,转换,编辑,制作,生成,动图';
useSeoMeta({
  title: title,
  keywords: keywords,
  ogTitle: title,
  description: description,
  ogDescription: description,
});

const routes = nestRoutes().filter((item) => item.path != '/' && item.path != '/about');
console.log(routes);

const recommendList = [
  {
    title: '无需安装',
    icon: 'no-download',
    desc: '无需安装任何软件，直接在浏览器中制作GIF',
  },
  {
    title: '安全可靠',
    icon: 'no-upload',
    desc: '网站不收集您的GIF文件，保证您的文件安全性',
  },
  {
    title: '不限参数',
    icon: 'unlimit',
    desc: '不限制GIF制作时的参数，您可以自由制作GIF',
  },
  {
    title: '不限尺寸',
    icon: 'size',
    desc: '不限制GIF的尺寸，构建任意大小的GIF',
  },
  {
    title: '不限文件大小',
    icon: 'picture-size',
    desc: '不限制操作的GIF的文件大小，保证任意GIF均可操作',
  },
  {
    title: '任意次数',
    icon: 'use-count',
    desc: '不限制任何使用次数，包括转换和下载',
  },
];
</script>
